<template>
  <div :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'">
    <div class="relative z-10 mb-10">
      <p class="text-xl font-bold text-center mb-6 max-w-244 md:max-w-xl mx-auto" :style="$themeStyle">
        {{ title }}
      </p>
    </div>
    <ul class="flex justify-center">
      <li class="mx-4" v-if="!!youtube">
        <a :href="youtube" target="_blank" @click="onLink(youtube)">
          <Icon
            id="youtube"
            :colorBackground="themePrimaryColor"
            color="#fff"
          />
        </a>
      </li>
      <li class="mx-4" v-if="!!instagram">
        <a :href="instagram" target="_blank" @click="onLink(instagram)">
          <Icon
            id="instagram"
            :colorBackground="themePrimaryColor"
            color="#fff"
          />
        </a>
      </li>
      <li class="mx-4" v-if="!!twitter">
        <a :href="twitter" target="_blank" @click="onLink(twitter)">
          <Icon
            id="twitter"
            :colorBackground="themePrimaryColor"
            color="#fff"
          />
        </a>
      </li>
      <li class="mx-4" v-if="!!facebook">
        <a :href="facebook" target="_blank" @click="onLink(facebook)">
          <Icon
            id="facebook"
            :colorBackground="themePrimaryColor"
            color="#fff"
          />
        </a>
      </li>
      <li class="mx-4" v-if="!!tiktok">
        <a :href="tiktok" target="_blank" @click="onLink(tiktok)">
          <Icon
            id="tiktok"
            :colorBackground="themePrimaryColor"
            color="#fff"
          />
        </a>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import cms from '@/cms'
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { ThemeHandler } from '../../mixins/theme-handler'
import { TranslationHandler } from '../../mixins/translation-handler'
import { PageModule, PageModuleDataSocial } from '../../types'

@Component({
})
export default class ModuleSocialBar extends Mixins(TranslationHandler, ThemeHandler) {
  @Prop() pageModule!: PageModule<PageModuleDataSocial>

  @Getter themePrimaryColor!: string
  @Getter themeIsDark!: boolean

  get title () {
    return this.pageModule.data[this.$tLocaleCurrent].title
  }

  get facebook () {
    return this.pageModule.data[this.$tLocaleCurrent].facebook
  }

  get twitter () {
    return this.pageModule.data[this.$tLocaleCurrent].twitter
  }

  get youtube () {
    return this.pageModule.data[this.$tLocaleCurrent].youtube
  }

  get instagram () {
    return this.pageModule.data[this.$tLocaleCurrent].instagram
  }

  get tiktok () {
    return this.pageModule.data[this.$tLocaleCurrent].tiktok
  }

  onLink (url: string) {
    cms.tracking.trackSocial('social_outbound_click', { social_link: url })
  }
}
</script>
